import request from "@/utils/request";
// 邮箱验证
export const emailAutoCode = data => {
	return request({
		url: "/emailAutoCode",
		method: "POST",
		data,
	});
}; 
// 信息验证
export const emailAutoCodeConfirm = data => {
	return request({
		url: "/emailAutoCode/confirm",
		method: "POST",
		data,
	});
};
// 修改密码
export const resetPassword = data => {
	return request({
		url: "/emailAutoCode/resetpassword",
		method: "POST",
		data,
	});
};
